var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}]},[_c('el-select',{attrs:{"value":_vm.value,"placeholder":_vm.label},on:{"change":_vm.onChange}},[_c('el-option',{attrs:{"label":_vm.$tc('yearly'),"value":"Yearly"}}),_c('el-option',{attrs:{"label":_vm.$tc('monthly'),"value":"Monthly"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }